enum AccountModalTab {
  CreateAccount = 'createAccount',
  SignIn = 'signIn',
  ForgotPassword = 'forgotPassword',
  ResetPassword = 'resetPassword'
}

export default AccountModalTab;
